import * as React from "react";
import { cn } from "@/lib/utils";

export const Label = React.forwardRef<HTMLLabelElement, React.LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...props }, ref) => (
    <label
      ref={ref}
      className={cn("block text-sm font-medium mb-1.5", className)}
      style={{ color: "var(--talenta-text)" }}
      {...props}
    />
  ),
);
Label.displayName = "Label";
